module.exports = __webpack_public_path__ + "img/akz.dff02b3b.png";